import React, { useContext } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import {
  FaSignOutAlt,
  FaCog
} from 'react-icons/fa'
import { AuthContext } from '../context/AuthContext'
import './TopBar.css'

export default function TopBar() {
  const { user, logout } = useContext(AuthContext)
  const userName = user?.name || 'User'
  const navigate = useNavigate()
  const location = useLocation()
  
  // Hide welcome section on inventory page
  const isInventoryPage = location.pathname === '/inventory'

  function handleLogout() {
    if (window.confirm('Are you sure you want to log out?')) {
      logout()
    }
  }

  return (
    <>
      <header className="topbar">
        <div className="topbar-container">
          {!isInventoryPage && (
            <div className="topbar-left">
              <h2 className="welcome-message">Welcome back, {userName}</h2>
            </div>
          )}
          
          <div className="topbar-right">
            <NavLink
              to="/settings"
              className="icon-button"
              title="Settings"
              style={{ margin: '0 8px' }}
            >
              <FaCog />
            </NavLink>
            <div className="topbar-actions">
              <button
                className="icon-button"
                title="IT Support"
                onClick={() => navigate('/it-support')}
                style={{ 
                  background: '#004080', 
                  color: 'white', 
                  border: 'none', 
                  padding: '10px 20px', 
                  borderRadius: '8px', 
                  fontWeight: '600',
                  fontSize: '14px',
                  cursor: 'pointer',
                  margin: '0 8px',
                  minWidth: '120px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#0056b3';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#004080';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
              >
                IT Support
              </button>
              <button
                className="icon-button logout-button"
                onClick={handleLogout}
                title="Log out"
              >
                <FaSignOutAlt />
              </button>
            </div>
          </div>
        </div>
      </header>


    </>
  )
}
